module.exports = __webpack_public_path__ + "img/liushui (9).e0338252.png";